/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_Field_LabelInputs */

const en_us2_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const pt_br2_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const es_419_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const pt_pt2_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const fr_fr2_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const de_de2_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const it_it2_auth_email_field_label = /** @type {(inputs: Auth_Email_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Auth_Email_Field_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_field_label = /** @type {((inputs?: Auth_Email_Field_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_Field_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_field_label(inputs)
	if (locale === "es-419") return es_419_auth_email_field_label(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_field_label(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_field_label(inputs)
	if (locale === "de-DE") return de_de2_auth_email_field_label(inputs)
	if (locale === "it-IT") return it_it2_auth_email_field_label(inputs)
	return en_us2_auth_email_field_label(inputs)
});
export { auth_email_field_label as "auth.email_field_label" }